import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('install_the_authenticator_app_for_fa'),
    description: defineMessage('use_the_authenticator_a_port_articlesupportlink'),
    enterManuallyButton: defineMessage('enter_the_key_manually'),
    copyCodeButton: defineMessage('copy_to_clipboard'),
    copyCodeResult: defineMessage('code_copied_to_clipboard'),
    nextButton: defineMessage('next'),
};
